import { Api } from '../api';
import { cards } from '../endpoints';
import {
  ApplyCardRequest,
  GetAllCardsResponse,
  GetProductsResponse,
  ChangePinCardResponse,
  GetAllStatementsResponse,
  PostDisputeTransactionsRequest,
  setCard3dsRequest,
  ChangeCardNewNameRequest,
  GetViewResponse,
} from './models';

export class CardsApi extends Api {
  static getCardsAll = (signal?: AbortSignal) => this.get<GetAllCardsResponse[]>({ url: cards.cardsAll(), signal: signal });

  static getCardsProducts = (signal?: AbortSignal) => this.get<GetProductsResponse[]>({ url: cards.cardsProducts(), signal: signal });

  static getCardsLatest = (signal?: AbortSignal) => this.get<GetAllCardsResponse>({ url: cards.cardsLatest(), signal: signal });

  static getInvoicesCard = (id: string, signal?: AbortSignal) => this.get<unknown>({ url: cards.invoices(id), signal: signal });

  static downloadInvoice = (id: string, signal?: AbortSignal) =>
    this.get<GetViewResponse>({ url: cards.invoicesDownload(id), responseType: 'blob', signal: signal });

  static printInvoice = (id: string, signal?: AbortSignal) =>
    this.get<GetViewResponse>({ url: cards.invoicesPrint(id), responseType: 'blob', signal: signal });

  static getStatementsCard = (id: string, signal?: AbortSignal) => this.get<unknown>({ url: cards.statements(id), signal: signal });

  static downloadStatements = (id: string, signal?: AbortSignal) =>
    this.get<GetViewResponse>({ url: cards.statementsDownload(id), responseType: 'blob', signal: signal });

  static printStatements = (id: string, signal?: AbortSignal) =>
    this.get<GetViewResponse>({ url: cards.statementsPrint(id), responseType: 'blob', signal: signal });

  static applyCard = (request: ApplyCardRequest, signal?: AbortSignal) =>
    this.post<ApplyCardRequest, undefined>({ url: cards.apply(), data: request, signal: signal });

  static changeNameCard = (request: ChangeCardNewNameRequest, id: string, signal?: AbortSignal) =>
    this.post<ChangeCardNewNameRequest, undefined>({ url: cards.changeName(id), data: request, signal: signal });

  static viewPinCard = (id: string, signal?: AbortSignal) => this.post({ url: cards.viewPin(id), signal: signal });

  static changePinCard = (request: ChangePinCardResponse, id: string, signal?: AbortSignal) =>
    this.post<ChangePinCardResponse, undefined>({ url: cards.changePin(id), data: request, signal: signal });

  static lostCard = (request: string, id: string, signal?: AbortSignal) =>
    this.post<string, undefined>({ url: cards.lost(id), data: request, signal: signal });

  static blockCard = (request: string, id: string, signal?: AbortSignal) =>
    this.post<string, undefined>({ url: cards.block(id), data: request, signal: signal });

  static getAllInvoicesCard = (cardId: string, signal?: AbortSignal) => this.get<[]>({ url: cards.allInvoices(cardId), signal: signal });

  static getAllStatementsCard = (cardId: string, signal?: AbortSignal) =>
    this.get<GetAllStatementsResponse[]>({ url: cards.allStatements(cardId), signal: signal });

  static getCardInvoicesView = (id: string, signal?: AbortSignal) => this.get<[]>({ url: cards.invoicesView(id), signal: signal });

  static getCardStatementsView = (id: string, signal?: AbortSignal) => this.get<[]>({ url: cards.statementView(id), signal: signal });

  static postDisputeTransactions = (request: PostDisputeTransactionsRequest, signal?: AbortSignal) =>
    this.post<PostDisputeTransactionsRequest, undefined>({ url: cards.postDisputeTransactions(), data: request, signal: signal });

  static getCard3ds = (id: string, signal?: AbortSignal) => this.get<[]>({ url: cards.get3ds(id), signal: signal });

  static setCard3ds = (request: setCard3dsRequest, cardId?: string, signal?: AbortSignal) =>
    this.post<setCard3dsRequest, undefined>({ url: cards.set3ds(cardId!), data: request, signal: signal });
}
